import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ClassifyLongForm(
    $customerId: ID!
    $allInstructionsData: JSON!
    $urlExtractions: [UrlExtractionInput!]
  ) {
    classifyLongForm(
      customerId: $customerId
      allInstructionsData: $allInstructionsData
      urlExtractions: $urlExtractions
    ) {
      template
    }
  }
`;

export const classifyLongForm = ({ customerId, allInstructionsData, urlExtractions }) => {
  allInstructionsData = JSON.stringify(allInstructionsData);
  return executeGqlMutation({
    mutation: MUTATION,
    variables: { customerId, allInstructionsData, urlExtractions },
  }).then(({ data }) => getSingleProp(data));
};
